import { getMySubOrders } from '../../../HttpRequests/subOrders'
import { setSubOrders } from '../State/subOrders'
import { startFetching, finishFetching } from '../State/fetching'
import { setPagination } from '../State/pagination'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch, getState) => {

  const { search, filters, sorting, pagination } = getState().screens.SubcontractorSubOrders

  const params = {
    search,
    sort: sorting.order ? `${sorting.order === 'descend' ? '-' : ''}${sorting.columnKey}` : '-date',
    include: [
      'subcontractor',
      'project.clientSite.client',
      'user',
    ].join(','),
    'page[number]': pagination.pageNumber,
    'page[size]': pagination.pageSize,
    // Filter for Awaiting Approval (2) and Approved (3) statuses only
    'filter[status_key]': '2,3',
  }

  if (filters.date_range.length) params['filter[date_range]'] = filters.date_range.map(date => date.format('YYYY-MM-DD')).join(',')

  dispatch(startFetching())

  try {

    const response = await getMySubOrders({ params })

    dispatch(setSubOrders(response.data.rows))

    dispatch(setPagination({
      pageNumber: response.data.pagination.current_page,
      pageSize: response.data.pagination.per_page,
      total: response.data.pagination.total,
    }))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(finishFetching())

  }

}
